module.exports = __webpack_public_path__ + "static/img/ewm.83bda7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ewm.png
// module id = 0r7s
// module chunks = 19